import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import { isFeatured, isLive } from "@/lib/hh";

const TILES = "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}";
const LABELS = "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}";
const ATTR = "Tiles &copy; Esri, HERE, Garmin, &copy; OpenStreetMap contributors";

const pinIcon = (v, active, num) =>
  num
    ? L.divIcon({ className: "", html: `<div class="hh-pin-num">${num}</div>`, iconSize: [26, 26], iconAnchor: [13, 13] })
    : L.divIcon({
        className: "",
        html: `<div class="hh-pin ${isFeatured(v) ? "featured" : isLive(v) ? "" : "closed"} ${active ? "active" : ""}"></div>`,
        iconSize: [24, 24],
        iconAnchor: [12, 12],
      });
const meIcon = L.divIcon({ className: "", html: '<div class="hh-me"></div>', iconSize: [14, 14], iconAnchor: [7, 7] });

function Fit({ points, focus }) {
  const map = useMap();
  const key = points.map((p) => p.join(",")).join("|");
  useEffect(() => {
    if (focus) return;
    if (points.length === 1) map.setView(points[0], 14);
    else if (points.length > 1) map.fitBounds(points, { padding: [40, 40], maxZoom: 15 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  useEffect(() => {
    if (focus) map.flyTo([focus.lat, focus.lng], Math.max(map.getZoom(), 14), { duration: 0.8 });
  }, [focus, map]);
  return null;
}

export function VenueMap({ venues, origin, selectedId, onSelect, route = false, className = "h-[420px]" }) {
  const located = venues.filter((v) => v.lat != null && v.lng != null);
  const points = located.map((v) => [v.lat, v.lng]);
  if (origin && !route) points.push([origin.lat, origin.lng]);
  const focus = located.find((v) => v.id === selectedId);
  const center = points[0] || [39.5, -98.35];
  return (
    <div data-testid="venue-map" className={`overflow-hidden rounded-2xl border border-zinc-800 ${className}`}>
      <MapContainer center={center} zoom={points.length ? 12 : 4} maxZoom={16} scrollWheelZoom className="h-full w-full">
        <TileLayer url={TILES} attribution={ATTR} maxZoom={16} />
        <TileLayer url={LABELS} maxZoom={16} />
        <Fit points={points} focus={focus} />
        {origin && !route && <Marker position={[origin.lat, origin.lng]} icon={meIcon} />}
        {located.map((v, i) => (
          <Marker
            key={v.id}
            position={[v.lat, v.lng]}
            icon={pinIcon(v, v.id === selectedId, route ? i + 1 : null)}
            eventHandlers={{ click: () => onSelect && onSelect(v.id) }}
          />
        ))}
        {route && points.length > 1 && <Polyline positions={points} pathOptions={{ color: "#fde68a", weight: 4, dashArray: "8 10" }} />}
      </MapContainer>
    </div>
  );
}
